import createResource from './createResource';
import { Diagnosis } from './types';

const diagnosesResource = createResource<Diagnosis>({
  key: 'diagnoses',
  url: '/diagnoses',
  });

  export default diagnosesResource;
